module.exports = __webpack_public_path__ + "resources/img/bg_banner_inquiry_m.bdf533eec5f6340a32b7d49ac00f62f5.png";